import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LightReturnStateService {
  lightReturnInitialised = false;
  shouldReloadGrid: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  shouldReloadGrid$ = this.shouldReloadGrid.asObservable().pipe(filter((v) => !!v));
}
